import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client, throwFriendlyApiError } from '../common';
import type { Reservation } from './types';

type Variables = {
  id: number;
  publicToken?: string;
};
export type AcceptAdditionalDriverRequest = {
  data: Reservation;
};

export const useAcceptAdditionalDriverRequest = createMutation<
  AcceptAdditionalDriverRequest,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/accept-invite`,
      method: 'POST',
      params: variables.publicToken
        ? { public_token: variables.publicToken }
        : undefined,
    })
      .then((response) => response.data)
      .catch((err: any) => throwFriendlyApiError(err, 'accept invite')),
});
